<app-breadcrumb [title]="ecomproduct?.products[0].name" class="hidevalue" [breadcrumb]="'ecomproduct'"></app-breadcrumb>
<!-- section start -->

<section class="section-b-space mobhite">
  <div class="collection-wrapper">
    <div class="container">
      <div class="waviy mt-3">
        <p *ngFor="let row of ecomprodpredefined">
          <span *ngIf="row?.qtyText === '2 Kg'" style="--i:1">Buy 2 KG – Pay for 1 KG, Get 1 KG Free!</span>
          <span *ngIf="row?.qtyText ===  '1.5 Kg'" style="--i:2">Buy 1.5 KG – Pay for 1 KG, Get 0.5 KG Free!</span>
        </p>
      </div>
      <div class="row">
        <div class="col-sm-3">
          <div class="collection-filter" [class.openFilterbar]="mobileSidebar">
            <!-- <div class="collection-filter-block">
              <div class="collection-mobile-back" (click)="toggleMobileSidebar()">
                <span class="filter-back">
                  <i class="fa fa-angle-left" aria-hidden="true"></i> back
                </span>
              </div>
              <app-categories></app-categories>
            </div> -->
            <div class="collection-filter-block ">
              <app-services></app-services>
            </div>
            <!-- <app-product-box-vertical-slider 
                  [title]="'New product'" 
                  [type]="product?.type"> 
                </app-product-box-vertical-slider> -->
          </div>
        </div>
        <div class="col-lg-9 col-sm-12 col-xs-12">
          <div class="container-fluid p-0">
            <div class="row hidevalue">
              <div class="col-xl-12">
                <div class="filter-main-btn mb-2">
                  <span class="filter-btn" (click)="toggleMobileSidebar()">
                    <i class="fa fa-bars" aria-hidden="true"></i> sidebar
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6" style="text-align: center;" *ngIf="prod">

                <img [defaultImage]="'assets/images/product/placeholder.jpg'" style="max-width: 85%;
                height: 550px;object-fit: cover;" [lazyLoad]="prod[0]?.imgUrl" [alt]="prod[0]?.imgUrl"
                  class="img-fluid">





                <!-- </div> -->

                <!-- <owl-carousel-o [options]="ProductDetailsMainSliderConfig" #owlCar class="product-slick">
                  <ng-container *ngFor="let image of ecomproduct?.products">
                    <ng-template carouselSlide>
                      <div class="fronthov">
                        <img [defaultImage]="'assets/images/product/placeholder.jpg'" [lazyLoad]="image.imgUrl"
                          [alt]="image.imgUrl" class="img-fluid">

                      </div>
                    </ng-template>
                  </ng-container>
                </owl-carousel-o> -->

                <!-- <div class="col-12 p-0" *ngIf="ecomproduct?.products.imgUrl.length > 1">
                  <div class="slider-nav">
                    <owl-carousel-o [options]="ProductDetailsThumbConfig" class="product-slick">
                      <ng-container *ngFor="let image of ecomproduct?.products index as i">
                        <ng-template carouselSlide [id]="i">
                          <div class="owl-thumb" [class.active]="i == activeSlide">
                            <img [defaultImage]="'assets/images/product/placeholder.jpg'" [lazyLoad]="image.imgUrl"
                              [alt]="image.imgUrl" class="img-fluid" (click)="owlCar.to(activeSlide = i.toString())">
                          </div>
                        </ng-template>
                      </ng-container>
                    </owl-carousel-o>
                  </div>
                </div> -->
              </div>

              <div class="col-lg-6 rtl-text">


                <div class="product-right" style="padding: 5px;">

                  <h2>{{ ecomproduct?.products[0].name }}</h2>



                  <h5>
                    <!-- <div class="media rating-sec"> -->

                    <!-- <div class="media-body ms-3" style="font-size: 20px;">
                        <div class="ratingmain three-star"> -->
                    <div class="row hidevalue" *ngIf="ecomproduct.datacount.total > 0">
                      <div class="d-flex flex-wrap  align-items-center text-center text-md-start">
                        <label class="mb-0 me-2" style="font-size: 1rem; color: #8d908f;">Rating</label>
                        <span class="mb-0 me-3" style="font-size: 1rem; color: #8d908f;">
                          {{ ecomproduct.datacount.total }}
                        </span>

                        <div class=" me-1" style="flex-shrink: 0;">
                          <bar-rating style="width: 100px;" [rate]="ecomproduct.datacount.total"
                            [readOnly]="true"></bar-rating>
                        </div>

                        <a href="javascript:void(0)" (click)="gotoreviewdiv()" class="text-decoration-none">
                          <span style="font-size: 0.9rem; color: #0070e7;">({{ ReviewData?.length }})</span>
                        </a>
                      </div>
                    </div>

                    <div class="row mobileview" *ngIf="ecomproduct.datacount.total > 0">
                      <div class="d-flex flex-wrap justify-content-center align-items-center text-center text-md-start">
                        <label class="mb-0 me-2" style="font-size: 1rem; color: #8d908f;">Rating</label>
                        <span class="mb-0 me-3" style="font-size: 1rem; color: #8d908f;">
                          {{ ecomproduct.datacount.total }}
                        </span>

                        <div class="mt-1 me-3" style="flex-shrink: 0;">
                          <bar-rating style="width: 100px;" [rate]="ecomproduct.datacount.total"
                            [readOnly]="true"></bar-rating>
                        </div>

                        <a href="javascript:void(0)" (click)="gotoreviewdiv()" class="text-decoration-none">
                          <span style="font-size: 0.9rem; color: #0070e7;">({{ ReviewData?.length }})</span>
                        </a>
                      </div>
                    </div>


                    <!-- <ng-container *ngFor="let star of [1, 2, 3, 4, 5]; let i = index">
                      <i class="fa" [ngClass]="getStarClass(i)" [ngStyle]="{'color': getStarColor(i)}"
                        style="font-size: 15px;"></i>
                    </ng-container> <a href="javascript:void(0)" (click)="gotoreviewdiv()"><span
                        style="margin-left: 5px;">({{ReviewData?.length}})
                      </span></a> -->


                    <!-- <label style="    font-size: 16px;    color: #8d908f;">Rating</label>
                      <span
                        style="    font-size: 16px;    color: #8d908f;    margin-left: 15px;    padding-right: 10px;">{{ecomproduct?.datacount.total
                        }}</span>
                        <bar-rating style="width: 20%;" [rate]="ecomproduct.datacount.total" [readOnly]="true"></bar-rating>
  
                       <a href="javascript:void(0)" (click)="gotoreviewdiv()"><span
                          style="margin-left: 5px;">({{ecomproduct?.datacount.starscount}})
                        </span></a> -->

                    <!-- </div>
                      </div> -->
                    <!-- </div> -->
                  </h5>

                  <h3>
                    &#8377; {{displayedPrice }}
                  </h3>


                  <!-- <h4>
                    <del *ngIf="product?.discount">{{ product?.price * productService.Currency?.price | currency:
                      productService.Currency?.currency:'symbol' }}</del>
                    <span>{{ product?.discount }}% off</span> 
                  </h4> -->
                  <!-- <h3>
                    {{ (product?.price | discount:product) * productService.Currency?.price | currency:
                    productService.Currency?.currency:'symbol' }}
                  </h3> -->
                  <!-- <ul class="color-variant" *ngIf="Color(product?.variants).length">
                    <li [class]="color" [class.active]="activeSlide == i.toString()"
                      *ngFor="let color of Color(product?.variants); index as i" [ngStyle]="{'background-color': color}"
                      (click)="owlCar.to(activeSlide = i.toString())">
                    </li>
                  </ul> -->
                  <!-- <app-stock-inventory [stock]="product?.stock"></app-stock-inventory> -->
                  <div class="product-description border-product">
                    <!-- <h6 class="product-title size-text" *ngIf="Size(product.variants).length">
                      select size
                      <span>
                        <a href="javascrip:void(0)" (click)="SizeChart.openModal()">size chart</a>
                      </span>
                    </h6>
                    <div class="size-box" *ngIf="Size(product.variants).length">
                      <ul>
                        <li [class.active]="selectedSize == size" *ngFor="let size of Size(product.variants)">
                          <a href="javascript:void(0)" (click)="selectSize(size)">
                            {{ size | titlecase }}
                          </a>
                        </li>
                      </ul>
                    </div> -->
                    <!-- <h5 class="avalibility" *ngIf="counter <= product.stock"><span>In Stock</span></h5>
                    <h5 class="avalibility" *ngIf="counter > product.stock"><span>Out of Stock</span></h5> -->
                    <h6 class="product-title">quantity</h6>
                    <div class="qty-box">
                      <div class="input-group">
                        <span class="input-group-prepend">
                          <button type="button" class="btn quantity-left-minus" data-type="minus" (click)="decrement()">
                            <i class="ti-angle-left"></i>
                          </button>
                        </span>
                        <!-- {{Cquantity}} -->
                        <input type="text" name="quantity" class="form-control input-number" [value]="counter"
                          maxlength="10" [(ngModel)]="counter" disabled />
                        <span class="input-group-prepend">
                          <button type="button" class="btn quantity-right-plus" data-type="plus" (click)="increment()">
                            <i class="ti-angle-right"></i>
                          </button>
                        </span>
                      </div>
                    </div>


                    <!-- WEIGHT 1-->
                    <h6 class="product-title size-text mt-3" *ngIf="prod[0].categoryId != 308">
                      Select Weight
                    </h6>

                    <div class="size-box hidevalue" *ngIf="prod[0].categoryId != 308">
                      <div class="row col-lg-12">
                        <button class="btn btn-outline m-2 w-auto"
                          [ngClass]="{'custom-color': row?.id === (preDEfQTy || topFirstProduct?.id)}"
                          style="padding: 10px 25px;border-radius: 8px;" *ngFor="let row of ecomprodpredefined"
                          (click)="updateDisplayedPrice(row.id, $event,row)">
                          {{ row?.qtyText }}
                          <!-- rs{{row?.price }} D -->
                        </button>
                      </div>
                    </div>

                    <div class="size-box mobileview" *ngIf="prod[0].categoryId != 308">
                      <div class="row col-lg-12">
                        <button class="btn m-2 w-auto" *ngFor="let row of ecomprodpredefined"
                          [ngClass]="{'custom-color': row?.id === (preDEfQTy || topFirstProduct?.id)}" style="padding: 4px 10px;
                            border-radius: 30px;    border-color: #ff4c3b;    margin: 3px !important; border-image: none;
                            height: 30px; font-size: 12px;" (click)="updateDisplayedPrice(row.id, $event,row )">
                          {{ row?.qtyText }}
                        </button>
                      </div>
                    </div>


                    <!-- Type 2-->
                    <h6 class="product-title size-text mt-3" *ngIf="ecomprodvariants.length > 0">
                      Type
                    </h6>

                    <div class="size-box hidevalue" *ngIf="ecomprodvariants.length > 0">
                      <div class="row col-lg-12">
                        <button class="btn btn-outline m-2 w-auto"
                          [ngClass]="{'custom-color': row.id == (VarId || topFirstPVariant?.id)}"
                          style="padding: 10px 25px;border-radius: 8px;" *ngFor="let row of ecomprodvariants"
                          (click)="updateDisplayedvarPrice(row.id)">
                          {{ row.qtyText }}
                          <!-- {{ row.price }} -->
                        </button>
                      </div>
                    </div>

                    <div class="size-box mobileview" *ngIf="ecomprodvariants.length > 0">
                      <div class="row col-lg-12">
                        <button class="btn m-2 w-auto" *ngFor="let row of ecomprodvariants"
                          [ngClass]="{'custom-color': row?.id == (VarId || topFirstPVariant?.id)}" style="   padding: 4px 10px;
                            border-radius: 30px;    border-color: #ff4c3b;    margin: 3px !important; border-image: none;
                            height: 30px; font-size: 12px;" (click)="updateDisplayedvarPrice(row.id)">
                          {{ row?.qtyText }}
                        </button>
                      </div>
                    </div>

                    <!-- Eggless 2-->
                    <h6 class="product-title size-text mt-3" *ngIf="ecomprodoptions.length > 0">
                      Eggless (Optional)
                    </h6>

                    <div class="size-box hidevalue" *ngIf="ecomprodoptions.length > 0">
                      <div class="row col-lg-12">
                        <button class="btn m-2 w-auto" *ngFor="let option of ecomprodoptions; let i = index"
                          [ngClass]="{'btn-unclicked': !clickedStates[i], 'btn-clicked': clickedStates[i]}"
                          style="padding: 10px 25px;border-radius: 8px; border-color: #ff4c3b; "
                          (click)="toggleButton(i, option.price,option,clickedStates[i],option.paProdId)">
                          {{ option.qtyText }}
                          <!-- {{ option.price }} -->
                        </button>
                      </div>
                    </div>

                    <div class="size-box mobileview" *ngIf="ecomprodoptions.length > 0">
                      <div class="row col-lg-12">
                        <button class="btn m-2 w-auto" *ngFor="let option of ecomprodoptions; let i = index"
                          [ngClass]="{'btn-unclicked': !clickedStates[i], 'btn-clicked': clickedStates[i]}" style="   padding: 4px 10px;
                            border-radius: 30px;    border-color: #ff4c3b;    margin: 3px !important; border-image: none;
                            height: 30px; font-size: 12px;"
                          (click)="toggleButton(i, option.price,option,clickedStates[i],option.paProdId)">
                          {{ option.qtyText }}
                        </button>
                      </div>
                    </div>

                    <!-- ---------------------end-------------------- -->

                    <!-- 
                  ----------------old s------------------
                    <h6 class="product-title size-text" *ngIf="ecomprodvariants.length > 0">
                      Type
                    </h6>
                    <div class="size-box" *ngIf="ecomprodvariants.length > 0">
                      <div class="row col-lg-12">
                        <button class="btn  m-2 w-auto"
                          [ngClass]="{'custom-color': row?.id == (VarId || topFirstPVariant?.id)}" style="   padding: 4px 10px;
                          border-radius: 30px;    border-color: #ff4c3b;    margin: 3px !important; border-image: none;
                          height: 30px;" *ngFor="let row of ecomprodvariants"
                          (click)="updateDisplayedvarPrice(row.id, $event)">
                          {{ row.qtyText }}m
                        </button>
                      </div>
                    </div>
                    <h6 class="product-title size-text" *ngIf="ecomprodoptions.length > 0">
                      Eggless (Optional)
                    </h6>
                    <div class="size-box" *ngIf="ecomprodoptions.length > 0">
                      <div class="row col-lg-12">
                        <button class="btn m-2 w-auto " style="   padding: 4px 10px;
                        border-radius: 30px;    border-color: #ff4c3b;    margin: 3px !important; border-image: none;
                        height: 30px;"
                          [ngClass]="{'btn-unclicked': !clickedStates[i], 'btn-clicked': clickedStates[i]}"
                          (click)="toggleButton(i, option.price,option,clickedStates[i])"
                          *ngFor="let option of ecomprodoptions; let i = index">
                          {{ option.qtyText }} W
                        </button>
                      </div>
                    </div>

                    ----------------old e------------------ -->


                    <div *ngIf="prod[0].categoryId != 70">{{prod.categoryId}}


                      <h6 class="product-title size-text" *ngIf="prod[0].categoryId != 308">
                        Message
                        <!-- <a class="text-danger">*</a> -->

                        <span class="message-length">{{ message.length }}/50</span>
                      </h6>


                      <div class="size-box" *ngIf="prod[0].categoryId != 308">
                        <input type="text" name="message" class="form-control input-number" [(ngModel)]="message"
                          [value]="message" autocomplete="off" placeholder="Eg: Happy Birthday Sweet Heart ❤️"
                          maxlength="50" (ngModelChange)="chatmsg()" required style="cursor: pointer;" />
                      </div>

                      <!--  
                      <div class="size-box" [formGroup]="productsideForm">
                        <input type="text" name="message" class="form-control input-number" [(ngModel)]="message"
                          formControlName="message" [value]="" autocomplete="off"
                          placeholder="Eg: Happy Birthday Sweet Heart ❤️" maxlength="50" (ngModelChange)="chatmsg()"
                          required />

                        <div *ngIf="f.message.invalid && (f.message.dirty || submitted)" class="text text-danger">
                          <div *ngIf="f.message.errors.required">Message is required.</div>
                          <div *ngIf="f.message.errors.maxlength">Message must be at most 50 characters long.</div>
                        </div>
                      </div> -->


                    </div>
                  </div>

                  <div class="product-buttons" style="padding-top: 10px;">
                    <a [routerLink]="['/shop/collection/left/sidebar']" style="margin-right: 10px;"
                      class="btn btn-solid btn-sm me-sm-3">Back</a>

                    <!-- <a class="btn btn-solid" (click)="addToCart(ecomproduct)">add to cart</a> -->
                    <button class="btn btn-solid " *ngIf="buttonText === 'Add to Cart'"
                      (click)="addToCart(ecomproduct)">{{
                      buttonText }}</button>

                    <button class="btn btn-solid" *ngIf="buttonText === 'Go to Cart'" (click)="goToCart(ecomproduct)">{{
                      buttonText }}</button>
                    <!-- <a class="btn btn-solid" (click)="buyNow(ecomproduct)">buy now</a> -->
                  </div>


                  <!-- <div class="border-product">
                    <h6 class="product-title">product details</h6>
                    <p>{{ ecomproduct?.products.name}}</p>
                  </div> -->
                  <div class="border-product">
                    <!-- <h6 class="product-title">share it</h6> -->
                    <div class="product-icon">
                      <!-- <app-social></app-social> -->
                      <!-- <a href="javascript:void(0)" title="Add to cart" (click)="itemshare()">
                        <i class="fa fa-share-alt" aria-hidden="true" style="color: black; margin-right: 10px;"> </i>
                        <span class="title-font" style="color: black;">Share</span>
                    </a> -->

                      <form class="d-inline-block">
                        <button class="wishlist-btn" (click)="itemshare()">
                          <i class="fa fa-share-alt" style="border-left: #ffffff;"></i>
                          <span class="title-font">Share</span>
                        </button>
                      </form>
                      <!-- <form class="d-inline-block">
                      <button class="wishlist-btn" (click)="itemshare()">
                        <i class="fa fa-share-alt" aria-hidden="true" > </i>
                        <span class="title-font">Share</span>
                      </button>
                    </form> -->

                      <form class="d-inline-block" *ngIf="favbool">
                        <button class="wishlist-btn" (click)="saveFav(product)">
                          <i class="fa fa-heart" style="color: red;"></i>
                          <span class="title-font" style="color: red;">Remove From WishList</span>
                        </button>
                      </form>

                      <form class="d-inline-block" *ngIf="!favbool">
                        <button class="wishlist-btn" (click)="saveFav(product)">
                          <i class="fa fa-heart"></i>
                          <span class="title-font">Add To WishList</span>
                        </button>
                      </form>


                    </div>
                  </div>
                  <div class="border-product">
                    <!-- <app-countdown [date]="'Apr 21 2021'"></app-countdown> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <!-- <h1>{{ReviewData.length}}</h1> -->
          <section #reviewDiv class="tab-product m-0" style="padding-bottom: 100px;" *ngIf="ReviewData.length > 0">
            <div class="row">
              <div class="col-sm-12 col-lg-12">

                <h4 style="font-size: 20px;font-weight: 700;">Product Review</h4>
                <div class="media rating-sec">
                  <label style="    font-size: 20px;    color: #8d908f;">Rating</label>
                  <span style="    font-size: 20px;    color: #8d908f;    margin-left: 15px;">{{finalratingstar
                    }}</span>
                  <div class="media-body ms-3" style="font-size: 20px;">
                    <div class="ratingmain three-star">

                      <ng-container *ngFor="let star of [1, 2, 3, 4, 5]; let i = index">
                        <i class="fa" [ngClass]="getStarClass(i)" [ngStyle]="{'color': getStarColor(i)}"></i>
                      </ng-container>
                    </div>
                  </div>
                  <span style="margin-left: 15px;margin-top: 6px;    color: #8d908f;"
                    *ngIf="review">{{ReviewData?.length}}
                    <span>reviews</span></span>
                </div>

                <div class="col-lg-12" style="    overflow: overlay;">
                  <div class="col-10" style="margin-top: 15px;border-bottom: 3px solid #f2f2f2"
                    *ngFor="let data of FilterReviewData">
                    <div style="display: inline-flex;    padding-bottom: 5px;">
                      <span style="width: auto;"><strong>{{data.notes?.name}} </strong> </span>
                      <div class="media-body ms-3">
                        <div class="rating1 three-star">
                          <ng-container *ngFor="let star of [1, 2, 3, 4, 5]; let i = index">
                            <i class="fa" [ngClass]="{'fa-star': i < data.star, 'fa-star-o': i >= data.star}"
                              [ngStyle]="{'color': i < data.star ? '#ffa200' : '#ccc'}"></i>
                          </ng-container>
                        </div>
                      </div>
                    </div> <br>
                    <div style="    margin-bottom: 2px;">
                      <span style="color: #8d908f;font-size: 13px;font-weight: 400;"><strong>{{data.createdDateTime |
                          date: "d MMM
                          Y "}} </strong>
                      </span>

                      <span
                        style="color: #8d908f;font-size: 13px;font-weight: 400;;margin-left: 15px;"><strong>{{data.notes?.city}}
                        </strong> </span>
                    </div>

                    <span>{{data.desc}}</span>
                    <div class="image-rating" style="    margin-bottom: 20px;" *ngIf="data.img?.length == 1">
                      <img loading="lazy" style="object-fit: cover;" src="{{data.img[0]?.url}}"
                        alt="Chocolate Truffle Cake" (click)="viewImg(data)">
                      <!-- <img *ngIf="data.img[1]?.url !=''" style="margin-left: 5px;object-fit: cover;" loading="lazy"
                        src="{{data.img[1]?.url}}" (click)="viewImg2nd(data)"> -->
                    </div>

                    <div class="image-rating" style="    margin-bottom: 20px;" *ngIf="data.img?.length > 1">
                      <img loading="lazy" style="object-fit: cover;" src="{{data.img[0]?.url}}"
                        alt="Chocolate Truffle Cake" (click)="viewImg(data)">
                      <img style="margin-left: 5px;object-fit: cover;" loading="lazy" src="{{data.img[1]?.url}}"
                        (click)="viewImg2nd(data)">
                    </div>


                  </div>
                </div>
                <div style="margin-top: 10px;text-align: center;" *ngIf="ReviewData.length > 5">
                  <button class="btn btn-solid" style="padding: 5px 10px;" (click)="loadReviews()">Load More</button>

                </div>

              </div>
            </div>
          </section>
        </div>
      </div>

      <!-- <h1>{{prod.length}}</h1>
      <div class="col-sm-12 empty-cart-cls text-center" style="margin-top: 90px;" *ngIf="prod.length == 0">
        <img src="assets/images/icon-empty-cart.png" class="img-fluid mb-4">
        <h3><strong>Your Cart is Empty</strong></h3>
        <h4>Add something to make me happy :)</h4>
      </div> -->
    </div>
  </div>
  <!-- <app-related-product [type]="product?.type"></app-related-product> -->
</section>
<!-- <app-size-modal #sizeChart [product]="product"></app-size-modal> -->
<!-- Section ends -->









<!-- POPUP -->


<ng-template #loginModel let-modal>
  <div class="modal-body">
    <div class="container-fluid p-0">
      <div class="row">
        <div class="modal-body">
          <h3 style="color: black;">
            <span style="font-size: 22px;">Welcome to FB Cakes
            </span>
          </h3> <br>

          <strong style="font-weight: 700;">
            <label for="">You are Not Logged In, Please Login to proceed to Cart!..</label>
            <!-- <h5>Your Not Logged In, Please Login to proceed to checkout!..</h5> -->
          </strong>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-solid" data-dismiss="modal"
            (click)="modal.dismiss('Cross click')">Close</button>
          <button type="button" class="btn btn-solid" (click)="logincheck()">Login</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #RecomendProd let-modal>
  <div class="modal fade show d-block" *ngIf="Recprod.length > 0">
    <div class="modal-dialog modal-xl">
      <div class="modal-content d-flex flex-column" style="height: 96vh;">

        <!-- Header: Fixed -->
        <div class="modal-header bg-white p-3 border-bottom d-flex justify-content-between align-items-center">
          <h3 class="text-dark">Make it extra special</h3>
          <button type="button" (click)="modal.dismiss('Cross click')" class="close" aria-label="Close"
            style="position: absolute; top: 10px; right: 15px; font-size: 24px; border: none; background: transparent;">
            ×
          </button>
        </div>

        <!-- Scrollable Content -->
        <div class="modal-body flex-grow-1 overflow-auto">
          <div class="container-fluid p-0">
            <div class="row img-wrapper1 d-flex flex-wrap justify-content-start g-1">
              <div class="col-12 col-md-4 col-lg-3 p-1 custom-spacing" *ngFor="let prd of Recprod">

                <div class="product-card p-2 border rounded shadow-sm bg-white text-center d-flex flex-column">
                  <div class="col-lg-12" style="background-color: antiquewhite;                
                  text-align: -webkit-center;">
                    <div class="col-lg-6">
                      <a href="javascript:void(0)">
                        <div class="image-container">
                          <img class="img-fluid lazy-loading" [defaultImage]="'assets/images/product/placeholder.jpg'"
                            [lazyLoad]="prd.imgUrl" alt="{{ prd.name }}" />
                        </div>
                      </a>
                    </div>
                  </div>
                  <h6 class="text-dark mt-2 flex-grow-1">{{ prd?.name }}</h6>
                  <h4 class="text-dark"><strong>₹ {{ prd?.price }}</strong></h4>

                  <div class="qty-box text-center mt-auto">
                    <div class="input-group d-flex align-items-center justify-content-center">
                      <button type="button" class="btn btn-outline-secondary" (click)="decrement1(prd)">-</button>
                      <input type="text" class="form-control text-center mx-1" [value]="prd.Qty" disabled />
                      <button type="button" class="btn btn-outline-secondary" (click)="increment1(prd)">+</button>
                    </div>
                    <!-- <button class="btn btn-outline-success btn-sm mt-2 w-100" (click)="addRecItem(prd)">ADD</button> -->
                    <button class="btn btn-sm mt-2 w-100"
                      style="color: #ff4c3b; border: 1px solid #ff4c3b; background-color: transparent;"
                      (click)="addRecItem(prd)">
                      ADD
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer: Fixed -->
        <div class="modal-footer bg-white p-3 border-top d-flex justify-content-between">
          <div>
            <span>Base Price:</span> <strong>₹ {{ displayedPrice }}</strong>
          </div>
          <div>
            <span>Add-ons:</span> <strong>₹ {{ RecTotal }}</strong>
          </div>
          <div>
            <span class="text-muted">Total:</span> <strong>₹ {{ displayedPrice + RecTotal }}</strong>
          </div>
          <button *ngIf="RecQTy == 0" class="btn btn-solid btn-xs" (click)="Contcart()">
            Continue Without Addons
          </button>
          <button *ngIf="RecQTy != 0" class="btn btn-success px-4 py-2 rounded-pill" (click)="Contcart()">
            Continue Cart ({{ RecQTy }} Addons)
          </button>
        </div>

      </div>
    </div>
  </div>
</ng-template>


<!-- <div class="hidevalue">
<ng-template #RecomendProd let-modal >
  <div class="modal-body">
    <div class="container-fluid p-0">
      <div class="row">
        <div class="modal-body">
          <h3 style="color: black;">
            <span style="font-size: 22px;">Recommended Products..
            </span>
          </h3> <br>
          <div class="img-wrapper1 row">
            <div class="col-6 col-md-3 pt-3" *ngFor="let prd of Recprod">
              <div class="front">
                <a [routerLink]="['/shop/product/left/sidebar/', prd.name]">
                  <img [defaultImage]="ImageSrc ? ImageSrc : 'assets/images/product/placeholder.jpg'"
                    [lazyLoad]="ImageSrc ? ImageSrc : prd.imgUrl" class="img-fluid lazy-loading"
                    alt="{{ prd.imgUrl }}" />
                </a>
              </div>
              <div class="product-detail">
                <div>
                  <bar-rating [rate]="5" [readOnly]="true"></bar-rating>

                  <h6>{{ prd?.name }}</h6>
                  <h4>
                    <strong class="kg">₹ {{ prd?.price}}</strong>
                  </h4>
                </div>
              </div>

              <div class="qty-box mt-2">
                <div class="input-group" style="justify-content: flex-start;">
                  <span class="input-group-prepend">
                    <button type="button" class="btn quantity-left-minus" data-type="minus" (click)="decrement1(prd)">
                      <i class="ti-angle-left"></i>
                    </button>
                  </span>
                  <input type="text" style="width: 60px;" name="quantity" class="form-control input-number"
                    [value]="prd.Qty" maxlength="10" disabled />
                  <span class="input-group-prepend">
                    <button type="button" class="btn quantity-right-plus" data-type="plus" (click)="increment1(prd)">
                      <i class="ti-angle-right"></i>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>



        </div>
        <div class="modal-footer fixed-bottom">
          <button type="button" class="btn btn-solid" data-dismiss="modal"
            (click)="modal.dismiss('Cross click')">Close</button>

        </div>
      </div>
    </div>
  </div>
</ng-template>
</div> -->

<div style="display: none;" id="preloaderpl">
  <!-- <img  alt=""> -->
  <div id="loaderpl">
    <div class="loaderzig">
      <div class="loader__part loader__part--1"></div>
      <div class="loader__part loader__part--2"></div>
      <div class="loader__part loader__part--3"></div>
    </div>
  </div>
</div>

<ng-template #ReviewImg let-modal>
  <div class="modal-container">
    <!-- Close button placed outside the main content -->
    <div class="close-button-container text-end mb-2">
      <button type="button" class="btn btn-sm btn-danger" (click)="modal.dismiss('Cross click')"
        style="border-radius: 50%; width: 35px; height: 35px; font-size: 18px; padding: 0;" aria-label="Close">
        &times;
      </button>
    </div>

    <div class="modal-body" style="max-height: 75vh; overflow-y: auto; overflow-x: hidden;">
      <div class="container-fluid p-0">
        <div class="row">
          <!-- Left Side: Main Review Image -->
          <div class="col-12 col-md-6" style="background-color: rgb(255, 240, 240);">
            <div *ngIf="reviewImage?.length">
              <div class="row">
                <div class="col-12 text-center" style="border-right: ridge;">
                  <img loading="lazy" style="max-height: 50vh; object-fit: contain; width: 100%;"
                    [src]="reviewImage[0]?.showImg" alt="Chocolate Truffle Cake" />
                </div>

                <!-- Thumbnails -->
                <div class="col-12 mt-3">
                  <div class="d-flex justify-content-center align-items-center" style="flex-wrap: wrap;">
                    <!-- <img *ngFor="let img of reviewImage[0]?.img; let i = index" loading="lazy"
                      style="width: 80px; height: 80px; object-fit: contain; margin: 5px; cursor: pointer;"
                      [src]="img?.url" (click)="viewImg(reviewImage)" [ngClass]="{
                        activateImg: img?.url === reviewImage[0]?.showImg
                      }" alt="Thumbnail Image" /> -->

                    <div *ngIf="Images.length == 2">
                      <img loading="lazy"
                        style="width: 80px; height: 80px; object-fit: contain; margin: 5px; cursor: pointer;"
                        src="{{reviewImage[0].img[0].url}}" alt="Chocolate Truffle Cake" (click)="viewimg1(reviewImage)"
                        [ngClass]="{'activateImg': reviewImage[0].img[0].url== reviewImage[0].showImg}">

                      <img *ngIf="reviewImage[0].img2 != ''" loading="lazy"
                        style="width: 80px; height: 80px; object-fit: contain; margin: 5px; cursor: pointer;"
                        src="{{reviewImage[0].img[1].url}}" alt="Chocolate Truffle Cake" (click)="viewimg2(reviewImage)"
                        [ngClass]="{'activateImg': reviewImage[0].img[1].url== reviewImage[0].showImg}">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Side: Review Details -->
          <div class="col-12 col-md-6" *ngIf="reviewImage?.length" style="border-bottom: 1px solid #f4f7f8;">
            <div class="px-3">
              <h5><strong>{{ reviewImage[0]?.notes?.name }}</strong></h5>
              <div class="rating mb-2">
                <ng-container *ngFor="let star of [1, 2, 3, 4, 5]; let i = index">
                  <i class="fa" [ngClass]="{
                      'fa-star': i < reviewImage[0]?.star,
                      'fa-star-o': i >= reviewImage[0]?.star
                    }" [ngStyle]="{
                      color: i < reviewImage[0]?.star ? '#ffa200' : '#ccc'
                    }"></i>
                </ng-container>
              </div>
              <div class="text-muted">
                <small>
                  <strong>{{ reviewImage[0]?.createdDateTime | date: 'd MMM Y'
                    }}</strong>
                  ·
                  <strong>{{ reviewImage[0]?.notes?.city }}</strong>
                </small>
              </div>
              <p class="mt-2">{{ reviewImage[0]?.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>











<!-- responsive -->


<ng-template #Reviews let-modal>
  <div class="modal-body" style="overflow: hidden;">
    <div class="container-fluid p-0" style="max-height: 75vh;">
      <div class="row">
        <div class="col-12 d-flex flex-wrap p-3">
          <div class="col-12 col-md-3 text-center mb-3">
            <img [defaultImage]="'assets/images/product/placeholder.jpg'" [lazyLoad]="prod[0]?.imgUrl"
              [alt]="prod[0]?.imgUrl" class="img-fluid" style="max-width: 20vh; height: auto; border-radius: 8px;" />
          </div>
          <div class="col-12 col-md-9">
            <div class="d-flex align-items-center justify-content-between">
              <div style="padding-left: 10px;">
                <h4 class="mb-1">Rating: {{ finalratingstar }}</h4>
                <div class="ratingmain">
                  <ng-container *ngFor="let star of [1, 2, 3, 4, 5]; let i = index">
                    <i class="fa" [ngClass]="getStarClass(i)" [ngStyle]="{ color: getStarColor(i) }"></i>
                  </ng-container>
                </div>
              </div>
              <div>
                <span class="text-muted">{{ ReviewData?.length }} reviews</span>
              </div>
            </div>
            <h5 class="mt-3" style="padding-left: 10px;">{{ ecomproduct?.products[0].name }}</h5>
          </div>
        </div>
      </div>
      <div class="col-12 mt-3" style="overflow-y: auto; max-height: 25vh; padding: 0 15px;">
        <div class="review-card mb-3 pb-3 border-bottom" *ngFor="let data of ReviewData">
          <div class="d-flex align-items-center">
            <img src="https://via.placeholder.com/350x350" alt="" class="rounded-circle"
              style="width: 50px; height: 50px; margin-right: 10px;" />
            <div>
              <strong>{{ data.notes?.name }}</strong>
              <div class="rating">
                <ng-container *ngFor="let star of [1, 2, 3, 4, 5]; let i = index">
                  <i class="fa" [ngClass]="{ 'fa-star': i < data.star, 'fa-star-o': i >= data.star }"
                    [ngStyle]="{ color: i < data.star ? '#ffa200' : '#ccc' }"></i>
                </ng-container>
              </div>
              <span class="text-muted d-block">{{ data.createdDateTime | date: 'd MMM Y' }} - {{ data.notes?.city
                }}</span>
            </div>
          </div>
          <p class="mt-2">{{ data.desc }}</p>
          <div class="mt-2" *ngIf="data.img.length > 0 ">
            <img *ngFor="let img of data.img; let idx = index" [src]="img?.url" [alt]="'Review Image ' + (idx + 1)"
              style="width: 70px; height: 70px; object-fit: cover; margin-right: 5px; cursor: pointer;"
              (click)="viewImg(data)" />
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-end">
        <button type="button" class="btn btn-solid btn-xs" (click)="modal.dismiss('Cross click')">
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>




<ng-template #Share let-modal>
  <div class="modal-content">
    <div class="modal-body" style="overflow: hidden; background-color: #f9f9f9; border-radius: 10px;">
      <div class="container-fluid p-0">
        <div class="row">
          <!-- Header -->
          <div class="col-12 text-center py-3" style="border-bottom: 1px solid #ddd;">
            <h5 style="font-size: 18px; font-weight: bold; color: #333;">Share via</h5>
          </div>
          <!-- Social Media Share Links -->
          <div class="col-12 d-flex flex-wrap justify-content-center py-4">
            <div class="d-flex align-items-center flex-column mx-3" style="width: 80px;">
              <a href="" class="text-decoration-none" (click)="shareToInstagram()">
                <div class="share-icon rounded-circle d-flex align-items-center justify-content-center mb-2"
                  style="width: 50px; height: 50px; background: linear-gradient(45deg, #fd5949, #d6249f); color: #fff;">
                  <i class="fa fa-instagram"></i>
                </div>
                <span class="spantxt" style="font-size: 14px; color: #555;">Instagram</span>
              </a>
            </div>
            <div class="d-flex align-items-center flex-column mx-3" style="width: 80px;">
              <a href="" class="text-decoration-none" (click)="shareToFacebook()">
                <div class="share-icon rounded-circle d-flex align-items-center justify-content-center mb-2"
                  style="width: 50px; height: 50px; background: #1877f2; color: #fff;">
                  <i class="fa fa-facebook"></i>
                </div>
                <span class="spantxt" style="font-size: 14px; color: #555;">Facebook</span>
              </a>
            </div>
            <div class="d-flex align-items-center flex-column mx-3" style="width: 80px;">
              <a href="" class="text-decoration-none" (click)="shareToWhatsapp()">
                <div class="share-icon rounded-circle d-flex align-items-center justify-content-center mb-2"
                  style="width: 50px; height: 50px; background: #25d366; color: #fff;">
                  <i class="fa fa-whatsapp"></i>
                </div>
                <span class="spantxt" style="font-size: 14px; color: #555;">WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
        <!-- Footer -->
        <div class="modal-footer d-flex justify-content-end">
          <button type="button" class="btn btn-theme btn-sm px-4" (click)="modal.dismiss('Cross click')">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>